<waitLoading *ngIf="!isLoaded()"> </waitLoading>
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <!-- CABECERA -->
  <dossierHeader [projectId]="dossier.identifier" title="Control de expedientes" titleIcon="fas fa-tasks">
  </dossierHeader>
  <!-- BOTONERA -->
  <div class="buttonsHeader">
    <button class="btn btn-primary" aria-expanded="false" (click)="load()" style="margin: 1px;">
      <span><i class="fas fa-lg fa-sync-alt" aria-hidden="true"></i>
        Actualizar</span>
    </button>
    <button class="btn btn-outline-secondary" type="button" class="btn btn-outline-secondary" aria-expanded="false"
      (click)="uiService.routeBack()">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
      <span class="d-none d-md-inline"> {{ 'General.back' | translate }}</span>
    </button>
  </div>
  <!-- ZONA DE WIDGETS -->
  <div class="row">
    <div class="col-sm-6 col-12">
      <div class="widget style1 bg-danger">
        <div class="row">
          <div class="col-4">
            <i class="fas fa-exclamation-circle fa-5x"></i>
          </div>
          <div class="col-8 text-right">
            <h2 class="font-bold">
              <div>Reglas obligatorias</div>
              <div>{{ countPendingsBySeverity('mandatory') }}</div>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-12">
      <div class="widget style1 bg-info">
        <div class="row">
          <div class="col-4">
            <i class="far fa-question-circle fa-5x"></i>
          </div>
          <div class="col-8 text-right">
            <h2 class="font-bold">
              <div>Reglas opcionales</div>
              <div>{{ countPendingsBySeverity('optional') }}</div>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ARBOL DE REGLAS -->
  <div class="row">
    <p-treeTable [value]="groupedInfo">
      <ng-template pTemplate="header">
        <tr>
          <th class="">Regla</th>
          <!-- <th class="TEMP"></th> -->
          <th class="" style="width:200px;">Bloqueada</th>
          <th class="text-center" style="width: 150px">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr>
          <td>
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <span>
              <i class="fa {{ rowData.icono }}" aria-hidden="true"></i>
              {{ rowData.description }}
            </span>
          </td>
          <!-- <td>
            <div>executionType: {{ rowData.executionType }}</div>
            <div>type: {{ rowData.type }}</div>
            <div>state: {{ rowData.state }}</div>
          </td> -->
          <td>
            <span *ngIf="rowData.locked">
              <i class="fa fa-lock text-danger" aria-hidden="true"></i>
              [{{ rowData.lockedBy.identifier }}]
              {{ userService.calculateUserFullName(rowData.lockedBy) }}
            </span>
          </td>
          <td style="text-align: right;">
            <button *ngIf="isProcedureAuditable(rowData)" (click)="openAudit(rowData)" class="btn btn-sm btn-primary"
              style="margin: 1px;">
              <i class="fas fa-1-5x fa-tasks" aria-hidden="true"></i>
            </button>
            <button *ngIf="isProcedureExecutable(rowData)" (click)="executeProcedure(rowData)"
              class="btn btn-sm btn-outline-secondary" style="margin: 1px;">
              <i class="fa fa-1-5x fa-pencil " aria-hidden="true"></i>
            </button>
            <button *ngIf="isRuleExecutable(rowData)" (click)="executeRule(rowData)" class="btn btn-sm btn-primary"
              style="margin: 1px;">
              <i class="fas fa-1-5x fas fa-play" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-treeTable>
  </div>
</div>